export const EXTERNAL_LINK_PROPS = {
    target: '_blank',
    rel: 'noopener noreferrer',
};
